import React, {useState} from 'react';
import {TableLineLoader} from "../../front/loader/TableLineLoader";
import DateService from "../../../service/DateService";
import {NavLink} from "react-router-dom";
import {ApiService} from "../../../service/ApiService";
import {DeleteConfirme} from "../DeleteConfirme";
import {scrollTo} from "../../../service/ToolsService";
import {participant} from "../../../models/participant";

type ParticipantListProp = {
  participants: participant[]
  loading?: boolean,
  refresh: () => void,
}

export const ParticipantList = ({participants, loading, refresh}: ParticipantListProp) => {
  const [del, setDel] = useState(undefined as undefined | participant);

  const deleteParticipant = async (participant: participant) => {
    await ApiService.delete(`/participant/${participant.participantId}`);
    refresh();
  };

  return (
    <>
      <table className="table table-responsive table-hover border">
        <thead>
        <tr className="table-primary">
          <th>Nom</th>
          <th className="text-center w100px">Place</th>
          <th className="text-center w150px">Modification</th>
          <th className="w190px"></th>
        </tr>
        </thead>
        <tbody>
        {loading && (
          <tr>
            <td colSpan={4} className="pt-4 pb-4 ps-5 pe-5">
              <TableLineLoader/>
            </td>
          </tr>
        )}

        {!loading && participants.map((participant: participant, i: number) => (
          <tr key={i} className={`align-middle`}>
            <td>
              {participant.name}
            </td>
            <td className="text-center">
              {participant.rank ?? '~'}
            </td>
            <td className="text-center">
              {DateService
                .toLocaleString(participant.updatedAt ?? participant.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
              }
            </td>
            <td className="text-end">
              <NavLink to={`/admin/participant/edit/${participant.participantId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                <i className="fa-solid fa-pencil me-1"/> modifier
              </NavLink>
              <button className="btn btn-xs btn-danger" onClick={() => setDel(participant)}><i className="fa-solid fa-xmark me-1"/>supprimer</button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
      {del && (
        <DeleteConfirme confirme={(c: boolean) => {
          if (c) {
            deleteParticipant(del);
          }

          setDel(undefined);
        }}/>
      )}
    </>
  );
}
